import { useComponentModal } from '@/share/components';
import MyOrgListView from './my-org-list-view.vue';

export const useMyOrgListModal = () => {
    const { openEditor } = useComponentModal();
    const openMyOrgListModal = async (title, options) => {
        const res = await openEditor(title, MyOrgListView, {}, {
            fullscreen: false,
            showMaximize: false,
            showMinimize: false,
            ...options,
        });
        return Promise.resolve(res);
    };
    return {
        openMyOrgListModal,
    };
};
